import BuiltinToolEditor, {
  parseBuiltinToolId,
} from 'components/@home/@settings/Tabs/Agents/BuiltinToolEditor';
import SkillEditor from 'components/@home/@settings/Tabs/Agents/SkillEditor';
import ToolEditor from 'components/@home/@settings/Tabs/Agents/ToolEditor';
import { useAgentEdit } from 'components/@home/@settings/Tabs/Agents/AgentEditContext';
import InstructionsPanel, {
  INSTRUCTION_KINDS,
} from 'components/@home/@settings/Tabs/Agents/panels/InstructionsPanel';
import MetricsPanel from 'components/@home/@settings/Tabs/Agents/panels/MetricsPanel';
import OverviewPanel from 'components/@home/@settings/Tabs/Agents/panels/OverviewPanel';
import SkillsPanel from 'components/@home/@settings/Tabs/Agents/panels/SkillsPanel';
import TagsPanel from 'components/@home/@settings/Tabs/Agents/panels/TagsPanel';
import KnowledgePanel from 'components/@home/@settings/Tabs/Agents/panels/KnowledgePanel';
import ToolsPanel from 'components/@home/@settings/Tabs/Agents/panels/ToolsPanel';
import KnowledgeEditor from 'components/@home/@settings/Tabs/Agents/KnowledgeEditor';
import MetricEditor from 'components/@home/@settings/Tabs/Agents/MetricEditor';
import TagEditor from 'components/@home/@settings/Tabs/Agents/TagEditor';
import React from 'react';
import { useParams } from 'react-router';

export const OverviewRoute = () => {
  const { agent, flow, onSaveAgent, onSaveFlowColor } = useAgentEdit();
  return (
    <OverviewPanel
      agent={agent}
      flow={flow}
      onSaveDraft={onSaveAgent}
      onSaveFlowColor={onSaveFlowColor}
      showColorPicker
    />
  );
};

export const InstructionsRoute = () => {
  const { kind } = useParams();
  const { agent, skills, tools } = useAgentEdit();
  const safeKind = INSTRUCTION_KINDS.includes(kind) ? kind : 'base';
  return <InstructionsPanel agent={agent} skills={skills} tools={tools} kind={safeKind} />;
};

export const SkillsRoute = () => {
  const { agent, skills, tools, onSaveAgent, onCreateSkill } = useAgentEdit();
  return (
    <SkillsPanel
      agent={agent}
      skills={skills}
      tools={tools}
      onSaveAgent={onSaveAgent}
      onCreateSkill={onCreateSkill}
    />
  );
};

export const ToolsRoute = () => {
  const { agent, tools, skills, onSaveAgent } = useAgentEdit();
  return <ToolsPanel agent={agent} tools={tools} skills={skills} onSaveAgent={onSaveAgent} />;
};

export const KnowledgeRoute = () => {
  const { agent, knowledge, skills } = useAgentEdit();
  return <KnowledgePanel agent={agent} knowledge={knowledge} skills={skills} />;
};

export const KnowledgeEditorRoute = () => {
  const { knowledgeId } = useParams();
  if (!knowledgeId || knowledgeId === 'new') return null;
  return <KnowledgeEditor key={knowledgeId} knowledgeId={knowledgeId} embedded />;
};

export const TagsRoute = () => {
  const { agent, skills, tools, tags, onSaveAgent, onReloadTags } = useAgentEdit();
  return (
    <TagsPanel
      agent={agent}
      skills={skills}
      tools={tools}
      allTags={tags}
      onSaveAgent={onSaveAgent}
      onReloadTags={onReloadTags}
    />
  );
};

export const MetricsRoute = () => {
  const { agent, metrics, tags, onSaveAgent, onReloadMetrics } = useAgentEdit();
  return (
    <MetricsPanel
      agent={agent}
      allMetrics={metrics}
      tags={tags}
      onSaveAgent={onSaveAgent}
      onReloadMetrics={onReloadMetrics}
    />
  );
};

export const SkillEditorRoute = () => {
  const { skillId } = useParams();
  if (!skillId || skillId === 'new') return null;
  return <SkillEditor key={skillId} skillId={skillId} embedded />;
};

export const ToolEditorRoute = () => {
  const { toolId } = useParams();
  if (!toolId || toolId === 'new') return null;
  if (parseBuiltinToolId(toolId)) {
    return <BuiltinToolEditor key={toolId} embedded />;
  }
  return <ToolEditor key={toolId} toolId={toolId} embedded />;
};

export const TagEditorRoute = () => {
  const { tagId } = useParams();
  if (!tagId) return null;
  return <TagEditor key={tagId} tagId={tagId} />;
};

export const MetricEditorRoute = () => {
  const { metricId } = useParams();
  if (!metricId) return null;
  return <MetricEditor key={metricId} metricId={metricId} />;
};
